module.exports = __webpack_public_path__ + "img/configuration-outline.b7953d76.svg";